import { AbstractControl } from '@angular/forms';

export class PasswordValidator {

    static MatchPassword(ac: AbstractControl) {
       const password = ac.get('password').value;
       const confirmPassword = ac.get('confirmPassword').value;

        if (password != confirmPassword) {
            ac.get('confirmPassword').setErrors( {mismatchPassword: true} );
        } else {
            ac.get('confirmPassword').setErrors(null);
        }
    }

    static WeakPassword(ac: AbstractControl){
      const pass = ac.get('password').value;

      const variations = {
        digits: /\d/.test(pass),
        lower: /[a-z]/.test(pass),
        upper: /[A-Z]/.test(pass),
        nonWords: /\W/.test(pass),
      };

      let strength = 0;

      for (const check in variations) {
        if (variations[check]) {
 strength++; 
}
      }

      if (pass.length < 8) {
        ac.get('password').setErrors({shortPassword: true} );
      } else if (strength < 3) {
        ac.get('password').setErrors({weakPassword: true} );
      } else {
        ac.get('password').setErrors(null);
      }

    }
  }
